import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { PublicShell } from "@/components/PublicShell";
import { FranquiciasSection } from "@/components/FranquiciasSection";
import { LeadForm } from "@/components/LeadForm";
import { openAgente } from "@/components/AgenteFiin";

export default function FranquiciasPublic() {
  const [preset, setPreset] = useState({ vertical: "franquicia", message: "Me interesa una franquicia FiinBridge." });
  const onInterest = (plan) => { setPreset({ vertical: "franquicia", message: plan ? `Me interesa el plan ${plan.n}.` : "Me interesa una franquicia FiinBridge." }); openAgente({ vertical: "franquicia", plan: plan?.k }); };
  return (
    <PublicShell>
      <section className="ink grain hero-glow pt-20 pb-20" data-testid="franquicias-hero">
        <div className="mx-auto max-w-7xl px-5 grid lg:grid-cols-[1.2fr_.8fr] gap-10 items-end">
          <div>
            <p className="eyebrow fade-up" style={{ color: "#FFC629" }}>Red de franquicias · Emprende con FiinBridge</p>
            <h1 data-testid="franquicias-title" className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.02] tracking-tight fade-up delay-1">Tu franquicia financiera con tecnología, marca y <span className="brand-gradient-text">comisiones reales</span>.</h1>
            <p className="mt-6 max-w-xl text-base sm:text-lg text-white/65 leading-relaxed fade-up delay-2">Convenios negociados con bancos, fintechs, casa de bolsa y aseguradoras; plataforma con IA; ledger de comisiones y overrides por tu red. Tú vendes, nosotros ponemos el puente.</p>
            <div className="mt-8 flex flex-wrap gap-3 fade-up delay-3">
              <button type="button" onClick={() => onInterest(null)} data-testid="franquicias-hero-cta" className="btn-brand">Quiero una franquicia <ArrowRight size={16} /></button>
              <Link to="/simuladores?tab=franquicia" data-testid="franquicias-hero-sim" className="btn-ghost-light">Simular mi ROI</Link>
            </div>
          </div>
          <ul className="space-y-2 text-sm text-white/75 fade-up delay-4">{["Cuota inicial única desde $50,000 MXN", "Regalía 8 % · sin cuotas ocultas", "Ingresos por tu red: 5 / 3 / 2 / 1 / 0.5 % por nivel", "Territorio exclusivo en Starter, Deluxe y Business Hub", "Business Hub: pagos internacionales y Cash Management con revenue share"].map((x) => <li key={x} className="flex gap-2"><CheckCircle2 size={16} className="text-[#FFC629] shrink-0 mt-0.5" />{x}</li>)}</ul>
        </div>
      </section>
      <FranquiciasSection onInterest={onInterest} />
      <section id="asesoria" className="ink grain py-20 scroll-mt-16">
        <div className="mx-auto max-w-7xl px-5 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="eyebrow" style={{ color: "#FFC629" }}>Siguiente paso</p>
            <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight">Déjanos tus datos y dirección de franquicias te contacta.</h2>
            <p className="mt-4 text-white/65 leading-relaxed">Recibirás la Circular de Oferta de Franquicia, el modelo financiero y una sesión para definir tu territorio.</p>
          </div>
          <LeadForm preset={preset} />
        </div>
      </section>
    </PublicShell>
  );
}
